// Auth state tracking for the write-auth system.
//
// JWTs now live exclusively in httpOnly cookies managed by the server — JS
// cannot read them. This module tracks only which scope (admin / frontdesk)
// is active so the UI knows whether the user is logged in. Cookie validity
// is enforced server-side; a 401 response triggers the modality:auth-401
// event which clears this state and shows the login gate.

export const PREFERRED_WRITE_SCOPE_KEY = 'modalityPreferredWriteScope';

// Legacy keys kept as exports so existing removeItem calls in ModalityApp
// remain harmless (they just clear now-empty storage slots).
export const ADMIN_WRITE_TOKEN_KEY = 'modalityWriteTokenAdmin';
export const FD_WRITE_TOKEN_KEY = 'modalityWriteTokenFd';
export const FD_WRITE_TOKEN_PERSIST_KEY = 'modalityFdWriteTokenPersisted';

export function setPreferredWriteScope(scope) {
  if (typeof window === 'undefined') return;
  if (scope === 'admin' || scope === 'frontdesk') {
    sessionStorage.setItem(PREFERRED_WRITE_SCOPE_KEY, scope);
  } else {
    sessionStorage.removeItem(PREFERRED_WRITE_SCOPE_KEY);
  }
}

// No-ops: JWT storage is now handled by server-set httpOnly cookies.
export function setAdminWriteToken(_token) {}
export function setFdWriteToken(_token) {}
export function clearWriteTokens() {}

// No Authorization header needed — browser sends the httpOnly cookie automatically.
export function getWriteAuthHeaders() {
  return {};
}

// True when a write scope is active in this session. Cookie validity is
// checked server-side on every request; a 401 will clear this flag.
export function hasAnyWriteToken() {
  if (typeof window === 'undefined') return false;
  return Boolean(sessionStorage.getItem(PREFERRED_WRITE_SCOPE_KEY));
}

// Ask the server to expire the httpOnly cookie for the given scope.
// Fire-and-forget — callers should not await this.
export function clearAuthCookies(scope = 'all') {
  const query = scope !== 'all' ? `?scope=${scope}` : '';
  fetch(`/api/logout${query}`, { method: 'POST', credentials: 'include' }).catch(() => {});
}
